/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from "../ApiClient";
import ImHerePresenceBindingModel from '../model/ImHerePresenceBindingModel';
import ImHerePresenceResultModel from '../model/ImHerePresenceResultModel';
import ModelStateError from '../model/ModelStateError';

/**
* Presence service.
* @module api/PresenceApi
* @version 1.0.0
*/
export default class PresenceApi {

    /**
    * Constructs a new PresenceApi. 
    * @alias module:api/PresenceApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the presenceImHere operation.
     * @callback module:api/PresenceApi~presenceImHereCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImHerePresenceResultModel} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/PresenceApi~presenceImHereCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImHerePresenceResultModel}
     */
    presenceImHere(body, callback) {
      let postBody = body;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth2'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ImHerePresenceResultModel;

      return this.apiClient.callApi(
        '/api/Presence/ImHere', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}
